import styled from 'styled-components';

const StyledMenuContainer = styled.div`
	position: relative;
	width: 100%;
	min-width: 0;
	height: 122px;
	display: flex;
	align-items: center;
	gap: 40px;
	user-select: none;
	padding-right: 40px;
`;

export { StyledMenuContainer };
